import Item from './Item';
import withHandlers from 'recompose/withHandlers';
import {
  trackMultiInputRemove,
  trackMultiInputChanged
} from 'src/client/js/analytics/category/product';

const enhance = withHandlers({
  handleOnChangeItem: props => e => {
    trackMultiInputChanged();
    props.onChangeItem(props.index, e.target.value);
  },
  handleOnRemoveItem: props => () => {
    trackMultiInputRemove();
    props.onRemoveItem(props.index);
  },
});

export default enhance(Item);
